import React, { useState } from 'react';
import { useReveal } from '../lib/useReveal';
const PREVIEW_IMAGES = [{
  src: 'https://cdn.magicpatterns.com/uploads/oGEsxppJ6SfvkGkbi7ukjo/IMG_3023.jpg',
  alt: 'Páginas interiores del método'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/uTsAgzqMCDukWkjBPopWkT/IMG_3025.jpg',
  alt: 'Ejercicios y protocolos'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/hTuWv9UPTBw45xRfA7BHUr/IMG_3026.jpg',
  alt: 'Guías de implementación'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/65mkNdwMgRQtGDUWRGpQfd/IMG_3024.jpg',
  alt: 'Rituales y prácticas'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/dtoTpmivNK3Pzm3Pcf54GM/IMG_3027.jpg',
  alt: 'Diarios y registros'
}];
export function PreviewCarousel() {
  const [ref, vis] = useReveal();
  const [current, setCurrent] = useState(0);
  const goTo = (index: number) => setCurrent(index);
  const prev = () => setCurrent(c => c === 0 ? PREVIEW_IMAGES.length - 1 : c - 1);
  const next = () => setCurrent(c => c === PREVIEW_IMAGES.length - 1 ? 0 : c + 1);
  return <section className="bg-brand-primary py-12 md:py-16 px-4 sm:px-6 border-t border-brand-border-soft" data-id="element-217">
      <div className="container mx-auto max-w-4xl" data-id="element-218">
        <div ref={ref} className={`reveal text-center mb-10 ${vis ? 'is-visible' : ''}`} data-id="element-219">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-4 leading-tight text-brand-heading" data-id="element-220">
            👀 Mirá por dentro
          </h2>
          <p className="text-brand-subheading text-lg" data-id="element-221">
            Páginas reales del material que vas a recibir
          </p>
        </div>

        <div className="relative" data-id="element-222">
          <div className="relative overflow-hidden rounded-[16px] border border-brand-border-soft bg-white shadow-medium" data-id="element-223">
            <img src={PREVIEW_IMAGES[current].src} alt={PREVIEW_IMAGES[current].alt} className="w-full h-auto max-h-[70vh] object-contain mx-auto" data-id="element-224" />
            <button onClick={prev} className="absolute left-2 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/80 border border-brand-border-soft flex items-center justify-center text-brand-heading hover:bg-brand-cta hover:text-white transition-all z-10 shadow-sm" aria-label="Anterior" data-id="element-225">
              ‹
            </button>
            <button onClick={next} className="absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/80 border border-brand-border-soft flex items-center justify-center text-brand-heading hover:bg-brand-cta hover:text-white transition-all z-10 shadow-sm" aria-label="Siguiente" data-id="element-226">
              ›
            </button>
          </div>

          <p className="text-center text-brand-body text-sm mt-4 font-medium" data-id="element-227">
            {PREVIEW_IMAGES[current].alt}
          </p>

          <div className="flex justify-center gap-2 mt-4 overflow-x-auto pb-2" data-id="element-228">
            {PREVIEW_IMAGES.map((img, i) => <button key={i} onClick={() => goTo(i)} className={`flex-shrink-0 w-16 h-16 sm:w-20 sm:h-20 rounded-lg overflow-hidden border-2 transition-all ${i === current ? 'border-brand-cta shadow-soft' : 'border-brand-border-soft opacity-60 hover:opacity-100'}`} data-id="element-229">
                <img src={img.src} alt={img.alt} className="w-full h-full object-cover" data-id="element-230" />
              </button>)}
          </div>

          <div className="flex justify-center gap-2 mt-3" data-id="element-231">
            {PREVIEW_IMAGES.map((_, i) => <button key={i} onClick={() => goTo(i)} className={`w-2 h-2 rounded-full transition-all ${i === current ? 'bg-brand-cta w-6' : 'bg-brand-border-soft'}`} aria-label={`Ir a imagen ${i + 1}`} data-id="element-232" />)}
          </div>
        </div>
      </div>
    </section>;
}